import React, { useRef, useState, useEffect } from "react";
import ReactPlayer from "react-player";

/* export default class CustomPlayer extends Component {
  state = {
    seekTo: this.props.seekTo,
    isSeeked: false
  }
  ref = player => {
    this.player = player
  }
  componentDidUpdate(prevProps) {
    if (prevProps.seekTo !== this.state.seekTo && !this.state.isSeeked) {
      this.player.seekTo(prevProps.seekTo);
      this.state.isSeeked = true;
    }
  }

  render() {
    return ;
  }
} */

export default function CustomPlayer(props: any) {
  const [seekTo, setSeekTo] = useState(props.seekTo);
  const [isSeeked, setIsSeeked] = useState(false);
  let player: any = null;
  let ref = useRef<any>(null);
  if (ref.current) {
    player = ref.current.player;
  }

  function usePrevious<T>(value: T): T | undefined {
    const ref = useRef<T>();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  /* function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  } */

  const prevProps: any = usePrevious(seekTo);
  useEffect(() => {
    if (prevProps && prevProps.seekTo !== seekTo && !isSeeked) {
      player.seekTo(prevProps.seekTo);
      setIsSeeked(true);
    }
  });



  return (
    <>
      <ReactPlayer pip={true} width={'100%'} height="auto" ref={ref}  {...props} />
    </>
  )
}